module.exports = __webpack_public_path__ + "static/media/Question4.db76e7b2.svg";